import { Subject } from 'rxjs';
export enum Event {
  REFRESH_TOKEN = 'refresh_token',
  LOGOUT = 'logout'
}
export const sub = new Subject();
